module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "load-smooth",
      "mode": "out-in"
    }
  }, [(_vm.carregando) ? _c('div', {
    key: "antes"
  }, [_c('h2', {
    staticClass: "carregando"
  }, [_vm._v("Carregando...")])]) : _c('div', {
    key: "depois"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0751044b","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-loader/index.vue
// module id = Ufsi
// module chunks = 5